import { generatePath, Navigate, useParams } from 'react-router-dom';

/**
 * Navigates to a given route while preserving url param values
 *
 * Example:
 * If you want to redirect from "test/:id" to "new-test/:id",
 * this component ensures that "test/123" redirects to "new-test/123",
 * correctly preserving the actual "id" value
 */
export const NavigateWithParams = ({ to }: { to: string }) => {
  const params = useParams();
  const path = generatePath(to, params);

  return <Navigate to={path} replace />;
};
